module.exports = __webpack_public_path__ + "static/img/4.265cbaa0.png";